import {Component, Mixins} from 'vue-property-decorator';
import ContactInfo from '@/dvd-orders/components/ContactInfo.vue';
import {DvdOrderDetails, State} from '@/dvd-orders/DvdModel';
import CancelMixin from '@/dvd-orders/mixins/CancelMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import {Page} from '@/router';
import DvdSteps from '@/dvd-orders/components/DvdSteps.vue';

@Component({
    components: {
        ContactInfo,
        DvdSteps
    }
})
export default class DvdCheckout extends Mixins(CancelMixin, LoadingMixin) {
    get orderDetails(): DvdOrderDetails {
        return Object.assign({}, this.$store.state.dvdOrderDetails);
    }

    get canContinue(): boolean {
        return this.$store.getters.contactInfoComplete;
    }

    get states(): State[] {
        return this.$store.state.states;
    }

    get billingStateName(): string {
        return this.states.filter(state => state.id === this.orderDetails.billingInfo.stateId).pop()!.name;
    }

    async created() {
        await this.$store.dispatch('loadStates');
    }

    infoTheSameChanged(isInfoTheSame: boolean) {
        this.$store.commit('updateIsInfoTheSame', isInfoTheSame);
        if (isInfoTheSame) {
            this.changed('billing');
        }
    }

    changed(type: 'billing' | 'shipping') {
        if (type === 'billing') {
            this.$store.commit('updateBilling', this.orderDetails.billingInfo);
            if (this.orderDetails.isInfoTheSame) {
                this.$store.commit('updateShipping', Object.assign({}, this.orderDetails.billingInfo));
            }
        } else {
            if (!this.orderDetails.isInfoTheSame) {
                this.$store.commit('updateShipping', this.orderDetails.shippingInfo);
            }
        }
    }

    async continueClicked() {
        if (this.canContinue) {
            this.$router.push({ name: Page.REVIEW }).catch(() => {});
        }
    }

    infoSameLabelClicked() {
        this.infoTheSameChanged(!this.orderDetails.isInfoTheSame);
    }
}